import { createUseStyles } from 'react-jss'

export const style = {
  legend: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 16,
    flexWrap: 'wrap'
  },
  legendKey: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 8px'
  },
  legendKeyToggle: {
    extend: 'legendKey',
    cursor: 'pointer'
  }
}

export const useStyles = createUseStyles(style)
